export type Language = 'en' | 'zh-TW' | 'zh';

export interface Translations {
  senderPlaceholder: {
    form: string;
    chat: string;
  };
  contactForm: {
    welcome: string;
    pushButton: string;
    completeForm: string;
    start: string;
    submit: string;
  };
  phoneNumber: {
    label: string;
  };
  messageRating: {
    placeholder: string;
    title: string;
    cancel: string;
    submit: string;
  };
  /** IMBEE-8069 (T86) Area A — the welcome banner's pager. */
  welcomeBanner: {
    switch: string;
  };
}

const translations: Record<Language, Translations> = {
  en: {
    senderPlaceholder: {
      form: 'Complete the form to start chatting...',
      chat: 'Type your message...',
    },
    contactForm: {
      welcome: 'Welcome!',
      pushButton: 'Push the button to start chatting!',
      completeForm: 'Please complete the form to start chatting!',
      start: 'Start',
      submit: 'Submit',
    },
    phoneNumber: {
      label: 'Phone Number',
    },
    messageRating: {
      placeholder: 'Share Your Thoughts',
      title: 'Share Your Comment',
      cancel: 'Cancel',
      submit: 'Submit',
    },
    welcomeBanner: {
      switch: 'Switch',
    },
  },
  'zh-TW': {
    senderPlaceholder: {
      form: '請填寫表單以開始聊天...',
      chat: '輸入您的訊息...',
    },
    contactForm: {
      welcome: '歡迎！',
      pushButton: '點擊按鈕開始聊天！',
      completeForm: '請填寫表單以開始聊天！',
      start: '開始',
      submit: '提交',
    },
    phoneNumber: {
      label: '電話號碼',
    },
    messageRating: {
      placeholder: '分享您的想法',
      title: '分享您的評論',
      cancel: '取消',
      submit: '提交',
    },
    welcomeBanner: {
      switch: '換一批',
    },
  },
  zh: {
    senderPlaceholder: {
      form: '请填写表单以开始聊天...',
      chat: '输入您的消息...',
    },
    contactForm: {
      welcome: '欢迎！',
      pushButton: '点击按钮开始聊天！',
      completeForm: '请填写表单以开始聊天！',
      start: '开始',
      submit: '提交',
    },
    phoneNumber: {
      label: '电话号码',
    },
    messageRating: {
      placeholder: '分享您的想法',
      title: '分享您的评论',
      cancel: '取消',
      submit: '提交',
    },
    welcomeBanner: {
      switch: '换一批',
    },
  },
};

export function detectBrowserLanguage(): Language {
  const browserLang = navigator.language || (navigator as any).userLanguage || 'en';
  console.log(browserLang);
  const supportedLanguages: Language[] = ['en', 'zh-TW', 'zh'];

  if (supportedLanguages.includes(browserLang as Language)) {
    return browserLang as Language;
  }

  const langPrefix = browserLang.split('-')[0];
  if (langPrefix === 'zh-TW') {
    if (browserLang.includes('TW') || browserLang.includes('HK') || browserLang.includes('MO')) {
      return 'zh-TW';
    }
    return 'zh';
  }

  return 'en';
}

let currentLanguage: Language = detectBrowserLanguage();

export function setLanguage(lang: Language): void {
  currentLanguage = lang;
}

export function getLanguage(): Language {
  return currentLanguage;
}

export function t(): Translations {
  return translations[currentLanguage];
}

export const getTranslations = t;
